<template>
  <!-- READ ONLY MODE -->

  <div class="option-section" :style="{ width: vasModalWidthFind(question.restrainLengthValue) }" v-if="mode == 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <div v-if="!question.verticalScale">
      <div v-if="activityDetails && activityDetails.newLayout == true">
        <div class="row">
          <div class="col-md-3 pr-10">{{ question.minValueLabel }}</div>
          <div class="col-md-6">
            <ds-slider ref="slider" :value="question.minValue" direction="horizontal" class="horizontal-vue-slider" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
            <div class="pt-10 scaleLabels-vas">
              <span :style="{ 'margin-left': 15 + 'px' }">{{ question.minValue }}</span>
              <span class="pull-right">{{ question.maxValue }}</span>
            </div>
          </div>
          <div class="col-md-3">{{ question.maxValueLabel }}</div>
        </div>
      </div>
      <div v-else>
        <div class="scaleLabels-vas">
          <div :style="{ 'margin-left': 15 + 'px' }">
            {{ question.minValueLabel }}
          </div>
          <div class="pull-right text-align">{{ question.maxValueLabel }}</div>
        </div>
        <ds-slider ref="slider" :value="question.minValue" direction="horizontal" class="horizontal-vue-slider" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
        <div class="pt-10 scaleLabels-vas">
          <span :style="{ 'margin-left': 15 + 'px' }">{{ question.minValue }}</span>
          <span class="pull-right text-align">{{ question.maxValue }}</span>
        </div>
      </div>
    </div>
    <div v-if="question.verticalScale">
      <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ question.maxValue }}</span>
      <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ question.maxValueLabel }}</span>
      <ds-slider ref="slider" :value="question.minValue" direction="vertical" class="vertical-vue-slider-vas pl-20" width="2" :height="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
      <div class="scaleLabels" v-if="question.verticalScale">
        <span :style="{ 'margin-left': 30 + 'px' }">
          {{ question.minValue }}
        </span>
        <span :style="{ 'margin-left': 30 + 'px' }">
          {{ question.minValueLabel }}
        </span>
      </div>
    </div>
  </div>

  <div v-else-if="(mode = 'EDIT')" class>
    <div class="p-0">
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :class="{
            'right-position': activityDetails.customParticipantMessaging
          }"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="bg-white mt-30" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-lg-3 p-0">
        <span class="scale-info">Set scale values</span>
        <span class="fa fa-info-circle info-circle pl-10" aria-hidden="true" @click="toggleScaleInfo()" @blur="hideScaleInfo()" tabindex="-1"></span>
        <div class="info-circle-div scale-info-div" style="z-index: 10" v-show="scaleInfoDiv">
          <b>Horizontal scales</b>: minimum = displayed on left; maximum = displayed on right
          <br />
          <b>Vertical scales</b>: minimum = displayed on bottom; maximum = displayed on top
        </div>
        <div class="row form-group pt-3">
          <div class="col-lg-3 p-0 pt-10">Minimum</div>
          <div class="col-lg-7 pl-3">
            <input type="number" class="form-control input-style" placeholder="Enter value" min="-10000" max="10000" v-model="question.minValue" />
          </div>
        </div>
        <div class="row form-group pt-3">
          <div class="col-lg-3 p-0 pt-10">Maximum</div>
          <div class="col-lg-7 pl-3">
            <input type="number" class="form-control input-style" placeholder="Enter value" max="10000" v-model="question.maxValue" />
          </div>
        </div>
        <div>&nbsp;</div>
        <div class="row form-group pt-3"></div>
      </div>

      <div class="col-lg-4">
        <span class="scale-info pl-20">Set scale labels</span>
        <div class="row form-group pt-10">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-2 pl-0 pr-5 pt-10 text-right">
            <span>Minimum</span>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 pl-10">
            <input type="text" class="form-control input-style" placeholder="Enter label" v-model="question.minValueLabel" />
          </div>
        </div>

        <div class="row form-group pt-10">
          <div class="col-lg-3 col-md-3 col-sm-3 col-xs-2 pl-0 pt-10 pr-5 text-right">
            <span>Maximum</span>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 pl-10">
            <input type="text" class="form-control input-style" placeholder="Enter label" v-model="question.maxValueLabel" />
          </div>
        </div>

        <div class="row form-group pt-10">
          <div class="col-lg-4 col-md-3 col-sm-2 col-xs-4 pl-0 pt-10 pr-5 text-right">
            <span>Length (mm)</span>
            <span class="fa fa-info-circle info-circle pl-5" aria-hidden="true" @click="toggleVASLengthInfo()" @blur="hideVASLengthInfo()" tabindex="-1"></span>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 pl-10">
            <input type="text" class="form-control input-style" placeholder="Enter length" maxlength="25" :disabled="!question.canRestrainLength" v-model="question.restrainLengthValue" />
          </div>
          <div class="info-circle-div length-info-div" v-show="lengthInfoDiv">
            Restrained length restricts the width (or height) of the slide to a set length in millimeters.
          </div>
        </div>
        <div class="row form-group pt-10" v-if="question.isScaleType">
          <div class="col-lg-3 col-md-3 col-sm-2 col-xs-4 pl-0 pt-6 pr-2 text-right">
            <span>Score Preview</span>
          </div>
          <div class="col-lg-8 col-md-5 col-sm-5 col-xs-5 pl-10">
            <input type="text" class="form-control input-style" placeholder="Enter label" v-model="question.resultLabel" />
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import dsSlider from "@/lib/ds-slider-component";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";
import _ from "lodash";

export default {
  name: "ActivityStepVAS",
  mixins: [activityStepCustomMessage],
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: 1
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    dsSlider,
    quillEditor
  },
  data() {
    return {
      piecewiseActiveStyle: {
        backgroundColor: "#3498db"
      },
      labelActiveStyle: {
        color: "#3498db"
      },
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      intervals: [
        { name: " ", value: "0" },
        { name: "1", value: "1" },
        { name: "2", value: "2" },
        { name: "3", value: "3" },
        { name: "4", value: "4" },
        { name: "5", value: "5" },
        { name: "6", value: "6" },
        { name: "7", value: "7" },
        { name: "8", value: "8" },
        { name: "9", value: "9" },
        { name: "10", value: "10" },
        { name: "11", value: "11" },
        { name: "12", value: "12" },
        { name: "13", value: "13" }
      ],
      infoDiv: false,
      scaleInfoDiv: false,
      intervalInfoDiv: false,
      scoreInfoDiv: false,
      lengthInfoDiv: false,
      pointerInfoDiv: false,
      scaleValueInfoDiv: false,
      isAddHelpEnabled: false
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    changeLabelsLength(intervals) {
      if (intervals == 0 || !intervals) {
        this.$toastr.error("Please specify # of intervals.");
        return;
      } else if (intervals < 1 || intervals > 14) {
        this.$toastr.error("Minimum and maximum value of interval should be 1 to 13");
        return;
      }
      this.question.formattedLabels.length = intervals;
      this.$forceUpdate();
      if (!this.question.formattedLabels) {
        this.question.formattedLabels = [];
      }
      this.question.formattedLabels.length = intervals;
      this.$forceUpdate();
    },
    hideIntervalInfo() {
      this.intervalInfoDiv = false;
      this.$el.blur();
    },
    showIntervalInfo() {
      this.intervalInfoDiv = true;
      this.$el.focus();
    },
    toggleIntervalInfo() {
      if (this.intervalInfoDiv) {
        this.hideIntervalInfo();
      } else {
        this.showIntervalInfo();
      }
    },
    vasModalWidthFind(width) {
      if (width >= 25) {
        return width + 10 + "mm";
      } else if (width <= 24) {
        return width + 5 + "mm";
      }
    },
    toggleScaleInfo() {
      if (this.scaleInfoDiv) {
        this.hideScaleInfo();
      } else {
        this.showScaleInfo();
      }
    },
    hideScaleInfo() {
      this.scaleInfoDiv = false;
      this.$el.blur();
    },
    showScaleInfo() {
      this.scaleInfoDiv = true;
      this.$el.focus();
    },
    toggleVASLengthInfo() {
      if (this.lengthInfoDiv) {
        this.hideVASLengthInfo();
      } else {
        this.showVASLengthInfo();
      }
    },
    hideVASLengthInfo() {
      this.lengthInfoDiv = false;
      this.$el.blur();
    },
    showVASLengthInfo() {
      this.lengthInfoDiv = true;
      this.$el.focus();
    },
    hideScoreInfo() {
      this.scoreInfoDiv = false;
      this.$el.blur();
    },
    showScoreInfo() {
      this.scoreInfoDiv = true;
      this.$el.focus();
    },
    toggleScoreInfo() {
      if (this.scoreInfoDiv) {
        this.hideScoreInfo();
      } else {
        this.showScoreInfo();
      }
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        errorObj.isValid = false;
        errorObj.msg = "Step Title is required.";
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      if (question.minValue == null || question.minValue === "") {
        errorObj.isValid = false;
        errorObj.msg = "Please specify the minimum value";
        return errorObj;
      }

      if (question.maxValue == null || question.maxValue === "") {
        errorObj.isValid = false;
        errorObj.msg = "Please specify the maximum value";
        return errorObj;
      }

      if (Number(question.maxValue) == Number(question.minValue)) {
        errorObj.isValid = false;
        errorObj.msg = "Minimum and maximum values cannot be identical.";
        return errorObj;
      }

      // max values always less than min value
      if (Number(question.minValue) > Number(question.maxValue)) {
        errorObj.isValid = false;
        errorObj.msg = "Max value must be greater than Min value.";
        return errorObj;
      }

      // min max should have value in defined range
      if (Number(question.minValue) < -10000 || Number(question.maxValue) > 10000) {
        errorObj.isValid = false;
        errorObj.msg = "Min and Max values must be within -10,000 and 10,000 range";
        return errorObj;
      }
      if (question.restrainLengthValue === null || question.restrainLengthValue == "" || question.restrainLengthValue === undefined) {
        errorObj.isValid = false;
        errorObj.msg = "Enter a length as a whole number which is not greater than 150.";
        return errorObj;
      }
      const regExWholeNumber = "-?[0-9]+?";
      const regExpWholeNumber = new RegExp(`^${regExWholeNumber}$`);

      if (!regExpWholeNumber.test(question.restrainLengthValue)) {
        errorObj.isValid = false;
        errorObj.msg = "Enter a length as a whole number which is not greater than 150.";
        return errorObj;
      }

      if (question.restrainLengthValue > 150) {
        errorObj.isValid = false;
        errorObj.msg = "Enter a length as a whole number which is not greater than 150.";
        return errorObj;
      }

      return { isValid: true };
      //break;
    },
    init() {
      if (!this.question.id) {
        this.$set(this.question, "score", 0);
      }
    }
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    this.init();
  }
};
</script>

<style scoped lang="scss">
.option-section {
  &:after {
    content: "";
    clear: both;
    display: block;
  }
  .col-sm-3 {
    float: left;
  }
}

.scaleLabels {
  font-size: 12px;
  color: #666669;
}

.vertical-vue-slider {
  height: 300px !important;
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}

.add-help-text {
  right: 533px;
  padding: 12px 13px;
  top: -38px;

  &.right-position {
    right: 637px;
  }
}
.text-align {
  text-align: right;
}
</style>
